import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [authModal, setAuthModal] = useState(null);

  useEffect(() => {
    // If returning from Google OAuth, the AuthCallback component handles the
    // session exchange first — skip the /me check to avoid a 401 race.
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  const openAuth = (mode = "login") => setAuthModal(mode);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    setAuthModal(null);
    return data;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name: name || null });
    setUser(data);
    setAuthModal(null);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };

  const googleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + "/")}`;
  };

  return (
    <AuthContext.Provider value={{ user, ready, authModal, openAuth, login, register, logout, googleSignIn, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
